import React, { Component } from 'react';
import { isEmpty } from '../Common/Common';

import Group_Cell from '../Group/Group_Cell';
import Management_Point_Cell from '../Group/Group_Details/Management_Point_Cells/Cell';
import Scene_Cell from '../Scenes/Scene_Cell';

export default class Dashboard extends Component {
	constructor(props) {
		super(props);

		this.bookmark_list = {};
		let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
		if (isEmpty(controller_info.bookmark_list)) controller_info.bookmark_list = {};

		//list of points user has/has no access to
		let accessible_points = this.props.receiver.active_controller.auth.points;
		if (accessible_points == null) accessible_points = {};

		// Prepare Bookmarks
		//ALEX Solved Bug in Multi-site (modelInfo was still in F10 multisite, not the actual one) START
		let modelInfo = controller_info.model;

		if (this.props.receiver.active_controller.active_site != '' && this.props.receiver.active_controller.model == 'F10') {
			modelInfo = window.app.state.site_list[this.props.receiver.active_controller.active_site].attr.model;
		}
		//ALEX Solved Bug in Multi-site END

		if (modelInfo != 'F10') {
			if (controller_info.bookmark_list[this.props.receiver.active_controller.username] == null) {
				// If current user does not have a bookmark list yet
				this.bookmark_list.group = this.getBookmarkGroups(accessible_points);
			} else {
				// If current user already has a bookmark list
				let bookmark_list = controller_info.bookmark_list[this.props.receiver.active_controller.username];
				this.bookmark_list.group = this.updateBookmarkGroups(bookmark_list.group, accessible_points);
				this.bookmark_list.devices = this.getBookmarkDevices(bookmark_list.devices, accessible_points);
				this.bookmark_list.scenes = this.getBookmarkScenes(bookmark_list.scenes, accessible_points);
			}

			// Save into local storage
			controller_info.bookmark_list[this.props.receiver.active_controller.username] = this.bookmark_list;
			window.localStorage.setItem(this.props.receiver.active_controller.name, JSON.stringify(controller_info));
		} else {
			let site_id = this.props.receiver.active_controller.active_site;
			if (controller_info.bookmark_list[this.props.receiver.active_controller.username] != null) {
				if (controller_info.bookmark_list[this.props.receiver.active_controller.username][site_id] == null) {
					// If current user does not have a bookmark list yet
					this.bookmark_list.group = this.getBookmarkGroups(accessible_points);
				} else {
					// If current user already has a bookmark list
					let bookmark_list = controller_info.bookmark_list[this.props.receiver.active_controller.username][site_id];
					this.bookmark_list.group = this.updateBookmarkGroups(bookmark_list.group, accessible_points);
					this.bookmark_list.devices = this.getBookmarkDevices(bookmark_list.devices, accessible_points);
					this.bookmark_list.scenes = this.getBookmarkScenes(bookmark_list.scenes, accessible_points);
				}
			} else {
				controller_info.bookmark_list[this.props.receiver.active_controller.username] = {};
				// If current user does not have a bookmark list yet
				this.bookmark_list.group = this.getBookmarkGroups(accessible_points);
			}

			// Save into local storage
			controller_info.bookmark_list[this.props.receiver.active_controller.username][site_id] = this.bookmark_list;
			window.localStorage.setItem(this.props.receiver.active_controller.name, JSON.stringify(controller_info));
		}

		if (this.props.receiver.app_model == 'H') {
			this.state = {
				// For animations
				is_transition_message: window.app.is_first_time_open ? false : true,
				is_show_dashboard: window.app.is_first_time_open ? false : true,
			}
			this.handleAnimations();
		} else if (this.props.receiver.app_model == 'F' || this.props.receiver.app_model == 'M') {
			// Check this
			this.state = {
				is_show_dashboard: true,
			}
		}

		if (!window.app.content_area.current.switch_content.current.is_show_bottom_menu) {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		}
	}

	getBookmarkGroups = (accessible_points) => {
		let group = [];

		for (let group_id in this.props.param.groups) {
			// If user is a standard user, check if they have access to at least 1 mp in the group
			if (this.props.receiver.active_controller.user_class != 'Admin') {
				let group_info = this.props.param.groups[group_id];
				if (!isEmpty(group_info)) {
					let group_points = group_info.mp; //all the management points in the group
					if (group_points != null) {
						for (let j = 0; j < group_points.length; j++) {
							if (accessible_points.hasOwnProperty(group_points[j])) {
								if (accessible_points[group_points[j]]) {
									group.push(group_id);
									break;
								}
							}
						}
					}
				}
			}
			// If user is an admin, add all of the groups
			else group.push(group_id);
		}

		return group;
	}

	updateBookmarkGroups = (group, accessible_points) => {
		let temp_group = [];
		if (group != null && !isEmpty(this.props.param.groups)) {
			// If user is a standard user, check if they have access the mp
			if (this.props.receiver.active_controller.user_class != 'Admin') {
				//Groups bookmark - Check through the groups to see if user have access to at least 1mp in the group
				for (let grp_id of group) {
					if (!isEmpty(this.props.param.groups[grp_id])) {
						let group_points = this.props.param.groups[grp_id].mp;
						if (group_points != null) {
							for (let j = 0; j < group_points.length; j++) {
								if (accessible_points.hasOwnProperty(group_points[j])) {
									if (accessible_points[group_points[j]]) {
										temp_group.push(grp_id);
										break;
									}
								}
							}
						}
					}
				}
			} else {
				// Admin
				for (let grp_id of group) {
					if (this.props.param.groups[grp_id] != null) {
						temp_group.push(grp_id);
					}
				}
			}
		}
		return temp_group;
	}

	getBookmarkDevices = (devices, accessible_points) => {
		let temp_devices = [];

		//Devices bookmark - Check if mp can be accessible
		if (devices != null) {
			for (let j = 0; j < devices.length; j++) {
				if (this.props.receiver.active_controller.user_class != 'Admin') {
					if (accessible_points.hasOwnProperty(devices[j])) {
						if (window.app.state.point_list[devices[j]] != null) {
							temp_devices.push(devices[j]);
						}
					}
				} else {
					if (window.app.state.point_list[devices[j]] != null) {
						temp_devices.push(devices[j]);
					}
				}
			}
		}
		return temp_devices;
	}

	getBookmarkScenes = (scenes) => {
		let temp_scenes = [];
		//Scenes bookmark - Check if scene still exist
		if (scenes != null && !isEmpty(this.props.param.scenes)) {
			for (let scene_id of scenes) {
				if (!isEmpty(this.props.param.scenes[scene_id])) {
					temp_scenes.push(scene_id);
				}
			}
		}

		return temp_scenes;
	}

	handleAnimations = () => {
		// At first, check if app is first time launch.
		// Set timeouts to initiate animations, then show bottom menu bar
		if (window.app.is_first_time_open) {
			setTimeout(() => { this.setState({ is_transition_message: true, }) }, 1000);
			setTimeout(() => {
				this.setState({ is_show_dashboard: true, });
				window.app.content_area.current.switch_content.current.handleShowBottomMenu();
			}, 1750);
			window.app.handleSetNotFirstTime();
		} else {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		}
	}

	rcvExecuteScene = (response) => {
		if (response.result == 'OK') {
			window.app.showToast(this.props.receiver.getString('scene_success'), 3000);
		} else {
			window.app.showToast(this.props.receiver.getString('scene_fail'), 3000);
		}
	}

	render() {
		// If bookmark groups does not exist
		if (this.bookmark_list.group == null || this.bookmark_list.group == undefined) {
			this.bookmark_list.group = [];
		}

		// If bookmark devices does not exist
		if (this.bookmark_list.devices == null || this.bookmark_list.devices == undefined) {
			this.bookmark_list.devices = [];
		}

		// If bookmark scenes does not exist
		if (this.bookmark_list.scenes == null || this.bookmark_list.scenes == undefined
			|| this.props.receiver.active_controller.available_functions.scene != true) {
			this.bookmark_list.scenes = [];
		}

		let is_show_groups = false;
		let is_show_devices = false;
		let is_show_scenes = false;

		// Each cell width
		let groups_width = 175;
		let devices_width = 155;
		let scenes_width = 175;

		if (this.bookmark_list.group.length > 0) {
			// Favourite Groups label hide when no groups bookmarked
			if (!isEmpty(this.props.param.groups)) {
				for (let grp_id of this.bookmark_list.group) {
					let group_info = this.props.param.groups[grp_id];
					if (!isEmpty(group_info)) is_show_groups = true;
					break;
				}
			}

			if (this.props.width > this.props.height) { //If device orientation is landscape
				// If the width of the groups doesnt exceed the screen width, width will be the screen width
				if ((this.props.width - 40) > groups_width * Math.ceil(this.bookmark_list.group.length / 2)) groups_width = (this.props.width - 40);
				else groups_width = groups_width * Math.ceil(this.bookmark_list.group.length / 2);
			} else {
				if (this.bookmark_list.group.length > 2) {
					groups_width = groups_width * Math.ceil(this.bookmark_list.group.length / 2);
				}
			}
		}

		if (this.bookmark_list.devices.length > 0) {
			is_show_devices = true;

			if (this.props.width > this.props.height) { //If device orientation is landscape
				// If the width of the groups doesnt exceed the screen width, width will be the screen width
				if ((this.props.width - 40) > devices_width * Math.ceil(this.bookmark_list.devices.length / 2)) devices_width = (this.props.width - 40);
				else devices_width = devices_width * Math.ceil(this.bookmark_list.devices.length / 2);
			} else {
				if (this.bookmark_list.devices.length > 2) devices_width = devices_width * Math.ceil(this.bookmark_list.devices.length / 2);
			}
		}

		if (this.bookmark_list.scenes.length > 0) {
			is_show_scenes = true;

			if (this.props.width > this.props.height) { //If device orientation is landscape
				// If the width of the scenes doesnt exceed the screen width, width will be the screen width
				if ((this.props.width - 40) > scenes_width * Math.ceil(this.bookmark_list.scenes.length / 2)) scenes_width = (this.props.width - 40);
				else scenes_width = scenes_width * Math.ceil(this.bookmark_list.scenes.length / 2);
			} else {
				if (this.bookmark_list.scenes.length > 2) scenes_width = scenes_width * Math.ceil(this.bookmark_list.scenes.length / 2);
			}
		}

		// If only 2 cells in the screen, display it in a single row
		if (groups_width < 175 * 2) groups_width = 175 * 2;
		if (devices_width < 155 * 2) devices_width = 155 * 2;
		if (scenes_width < 175 * 2) scenes_width = 175 * 2;

		// Message display, eg. Good Morning, Hayashi
		let message = '';
		let message_style = { display: 'none' };

		if (this.props.receiver.app_model == 'H') {
			//For animations style
			let message_before = {
				fontSize: 20,
				height: 100,
				textAlign: 'center',
				position: 'fixed',
				top: (this.props.height - 20) / 2,
				left: (this.props.width - 220) / 2,
				transition: 'all 3s',
				color: 'black',
			}

			let message_after = {
				color: this.props.colours.dashboard_message_font,
				position: 'fixed',
				top: 20,
				left: 20,
				transition: 'all 3s',
				transform: 'translate(-20px, -20px)',
				fontSize: 24,
				width: this.props.width,
				height: 40,
				paddingTop: 20,
				paddingLeft: 20,
				background: this.state.is_show_dashboard ? this.props.colours.midnight_sky : this.props.colours.background,
				cursor: 'default',
			}

			message_style = message_before;
			if (this.state.is_transition_message) {
				message_style = message_after;
			}

			let now = new Date();
			if (now.getHours() > 4 && now.getHours() < 12) message = this.props.receiver.getString('good_morning');
			else if (now.getHours() >= 12 && now.getHours() < 18) message = this.props.receiver.getString('good_afternoon');
			else message = this.props.receiver.getString('good_evening');

			message = message + ', ' + this.props.receiver.active_controller.username;
		}

		return (
			<div id='dashboard_main' style={{ height: this.props.height, }}>
				<div id='top-page' style={{ height: this.props.height - 55 }}>
					<div id='message' style={message_style}>
						<span>{message}</span>
					</div>
					<div style={{ marginTop: this.props.receiver.app_model == 'H' ? 70 : 0, width: this.props.width, height: this.props.receiver.app_model == 'H' ? this.props.height - 125 : this.props.height - 55, overflow: 'auto', display: this.state.is_show_dashboard ? 'block' : 'none', position: 'fixed' }}>
						<div style={{ marginLeft: 20 }}>
							<div id='carousel_Summary' style={{ display: is_show_groups ? 'block' : 'none' }}>
								<span className='header' style={{ fontSize: 18 }}>{this.props.receiver.getString('fav_groups')}</span>
								<div id='carousel1' style={{ width: this.props.width - 40, overflowX: 'auto' }}>
									<div id='carousel2' style={{ width: groups_width, }}>
										{this.bookmark_list.group.map((grp_id) => {
											// App will crash if spam buttons too fast, always check if group_info is not empty
											let group_info = {};
											if (!isEmpty(this.props.param.groups)) group_info = this.props.param.groups[grp_id];
											if (!isEmpty(group_info)) {
												return (
													<Group_Cell
														group_info={group_info}
														id={grp_id}
														receiver={this.props.receiver}
														content_handler={this.props.content_handler}
														from={"Dashboard"}
													/>
												)
											} else {
												return null;
											}
										})}
									</div>
								</div>
							</div>
							<div id='Favourite-Devices' style={{ display: is_show_devices ? 'block' : 'none', }}>
								<span className='header' style={{ fontSize: 18 }}>{this.props.receiver.getString('fav_devices')}</span>
								<div id='carousel3' style={{ width: this.props.width - 40, paddingBottom: 15, overflowX: 'auto' }}>
									<div id='carousel4' style={{ width: devices_width, }}>
										{this.bookmark_list.devices.map((point_id) => {
											let point_info = window.app.state.point_list[point_id];
											if (!isEmpty(point_info)) {
												return (
													<Management_Point_Cell
														id={'carousel_' + point_id}
														height={this.props.height}
														receiver={this.props.receiver}
														key={point_id}
														point_id={point_id}
														point_info={point_info}
														content_handler={this.props.content_handler}
														group_info={null}
														from={'Dashboard'}
														groups={this.props.param.groups}
														scenes={this.props.param.scenes}
														param={this.props.param}
													/>
												)
											} else {
												return null;
											}

										})}
									</div>
								</div>
							</div>
							<div id='Favourite-Scenes' style={{ display: is_show_scenes ? 'block' : 'none' }}>
								<span className='header' style={{ fontSize: 18 }}>{this.props.receiver.getString('fav_scenes')}</span>
								<div id='carousel5' style={{ width: this.props.width - 40, overflowX: 'auto' }}>
									<div id='carousel6' style={{ width: scenes_width }}>
										{this.bookmark_list.scenes.map((scene_id) => {
											// App will crash if spam buttons too fast, always check if scene is not empty
											let scene = {};
											if (!isEmpty(this.props.param.scenes)) scene = this.props.param.scenes[scene_id];
											if (!isEmpty(scene)) {
												return (
													<Scene_Cell
														id={scene_id}
														receiver={this.props.receiver}
														scene={scene}
													/>
												)
											} else {
												return null;
											}
										})}
									</div>
								</div>
							</div>
							<div> &nbsp;&nbsp;&nbsp;</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}